export default __webpack_public_path__ + "static/media/programmer.d3060f7b.svg";